export const globalState = {
  store_faName: "کبیر بای",
  store_enName: "kabir buy",
};
